<template>
    <Section class="resources grid--resources section--max-width">
        <h2 v-if="title">{{ title }}</h2>

        <template v-if="!tabCategories || tabCategories.length === 0">
            <CardResource
                v-for="resource in resources"
                :key="resource.id"
                :isSearch="isSearch"
                :showArea="showArea"
                v-bind="resource"
            >
                {{ resource }}
            </CardResource>
        </template>

        <template v-else>
            <Tabs>
                <Tab
                    v-for="(category, ind) in tabCategories"
                    :key="`r-tab-${category}`"
                    :name="`${shrinkAreaTabTitles(category)} (${ getCategoryLength(category) })`"
                    :selected="ind === 0"
                >
                    <template v-if="getCategoryLength(category) > 0">
                        <CardResource
                            v-for="resource in filterResources(category)"
                            :key="resource.id"
                            :isSearch="isSearch"
                            :showArea="showArea"
                            v-bind="resource"
                        >
                            {{ resource }}
                        </CardResource>
                    </template>

                    <Content v-else>
                        <h3>No Resources</h3>
                        Sorry, there are no resources found in <strong>{{ category }}</strong>
                    </Content>
                </Tab>
            </Tabs>
        </template>
    </Section>
</template>

<script>
// import { kebabToTitle } from '@/helpers'

export default {
    props: {
        isSearch: { type: Boolean, default: false },
        showArea: { type: Boolean, default: false },
        resources: { type: Array, required: true },
        navReference: { type: String, default: 'resources' },
        title: { type: String }
    },

    data() {
        return {
            windowWidth: null
        }
    },

    created () {
        this.onResize()
        window.addEventListener('resize', this.onResize)
    },

    computed: {
        width () { return this.windowWidth },
        tabCategories () { return this.generateTabArrays('page_category') },
        resourceTypes () { return this.generateTabArrays('type') },
    },

    filters: {
        titleCase (val) {
            // return kebabToTitle(val)
            return val
        }
    },

    methods: {
        shrinkAreaTabTitles (val) {
            if (this.width < 990 || (this.width > 1200 && this.width < 1430)) {
                if (val == 'Presentation & Triage') return "Presentation"
                if (val == 'Assessment & Management') return "Assessment"
                if (val == 'Discharge & Referral') return "Discharge"
            }

            return val || 'Uncategorised'
        },

        onResize() {
            this.windowWidth = window.innerWidth
        },

        generateTabArrays (type) {
            // dynamically create the list of tabs
            const newArr = this.resources.reduce((acc, resource) => {
                if (acc.includes(resource[type])) return acc

                return [ ...acc, resource[type] ]
            }, [])

            return newArr
        },

        getCategoryLength (category) {
            return this.resources
                .filter(res => res.page_category === category).length
        },

        filterResources (category) {
            return this.resources
                .filter(res => res.page_category == category)
        }
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    }
}
</script>
